import { FunctionalComponent } from 'preact'
import ClampLines from 'react-clamp-lines'
import htmlParser from '../utils/htmlParser'

export interface CardWidgetTextProps {
  html: string
}

export const CardWidgetText: FunctionalComponent<CardWidgetTextProps> = ({
  html
}) => (
  <p className='card-widget-text'>
    <ClampLines
      id='featured-topic-view'
      lines={3}
      text={htmlParser.stripHtml(html) || ''}
      buttons={false}
    />
  </p>
)
